export default "__VITE_ASSET__CS8dlpOb__"